"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DocumentUploader", {
  enumerable: true,
  get: function get() {
    return _DocumentUploader["default"];
  }
});
var _DocumentUploader = _interopRequireDefault(require("./DocumentUploader"));